import type { Routes } from '@angular/router';

import { AGGREGATED_CLIENTS_ROUTES } from '#modules/clients/routes/aggregated-clients.routing';

export const AGGREGATED_RESOURCES_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/groups/aggregated-resources-layout/aggregated-resources-layout.component').then(
                (m) => m.AggregatedResourcesLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'clients',
            },
            {
                path: 'clients',
                loadChildren: () => AGGREGATED_CLIENTS_ROUTES,
            },
        ],
    },
];
